// Zone domain types -- projected from iteration 033 changes.md

export const ZONE_TYPES = ["field", "spectator", "parking", "facility"] as const;
export type ZoneType = (typeof ZONE_TYPES)[number];

export interface Zone {
  id: string;
  school_id: string;
  name: string;
  zone_type: ZoneType;
  latitude: number | null;
  longitude: number | null;
  created_at: Date;
  updated_at: Date;
}

// API response types

export interface ZonePublic {
  id: string;
  school_id: string;
  name: string;
  zone_type: ZoneType;
  latitude: number | null;
  longitude: number | null;
  created_at: string;
  updated_at: string;
  _actions: ZoneAction[];
}

export type ZoneAction = "view" | "edit" | "delete";

export interface ZoneListResponse {
  zones: ZonePublic[];
}

export interface ZoneResponse {
  zone: ZonePublic;
}
